<template>
    <div class="">
        <b-overlay :show="showoverlay_list" rounded="sm">
                
                <template v-if="is_trustee ==1">
                    <div class="clearfix company-form-container company-form-container-warapper">
                        <div class="company-form-container-title-wrapper">
                            <div class="col-sm-12 px-3 company-form-box-title">
                                Provident Fund Advances Awaiting Disbursement
                            </div>
                        </div>
                        <div class="col-md-12 company-form-container-content-wrapper">
                            <div v-if="loans.length>0">
                                <common-list :action_btn_text="action_btn_text" :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" is_pf="1" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list> 
                            </div>
                            <div v-else>
                                <div v-if="show_loader" class="list-no-data">
                                    <span class="d-block text-center">Looking for relevant data..</span>
                                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                </div>
                                <div v-else class="list-no-data">
                                    Looks like there is no PF advance application to show.
                                </div>
                            </div>
                            
                        </div>
                    </div>
                
                </template>
                <template v-else>
                    <div class="col-12 text-right pr-0">
                        <button v-if="$acl['pf/allloanapplications'] > 1" v-on:click="previewBankFile()" class="btn btn-primary position-static">Preview Bank File</button>
                    </div>
                    <div v-if="loans.length>0">
                        <common-list :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" is_pf="1" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list> 
                    </div>
                    <div v-else>
                        <div v-if="show_loader" class="list-no-data">
                            <span class="d-block text-center">Looking for relevant data..</span>
                            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                        </div>
                        <div v-else class="list-no-data">
                            Looks like there is no PF advance application to show.
                        </div>
                    </div>
                </template>
                
            
        </b-overlay>




        
        <b-modal id="bv-modal-loan-2" size="md" hide-footer v-bind:title="modal_title"> 
            <!-- <pf-loan-form :pageurl="this.$api_url" :flg="flg" :employee_id="0" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="getLoanData"></pf-loan-form>        -->
            <pf-loan-form-new-disburse :pageurl="this.$api_url" :flg="flg" :employee_id="emp_id" :employee_name="emp_name" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="getLoanData"></pf-loan-form-new-disburse>           
        </b-modal>

        <b-modal id="bv-modal-bank-file-preview" size="lg" hide-footer v-bind:title="modal_title">
            <b-overlay :show="show_bank_preview" rounded="sm">
           
                <div v-if="preview_list.length > 0 ">
                    <div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                        <div v-for="(detail, index) in preview_list" :key="detail.type" class="mb-4">

                            <div class="row justify-content-center">
                                Transaction type :  {{detail.type}}
                            </div>
                
                            <div class="row justify-content-center">
                                File Name :  {{detail.file_name}}
                            </div>
                            
                            <div class="clearfix border rounded mt-3 mr-3 px-0 mb-0 col-md-12 table-wrapper-bank-preview">
                            <table class="table ">
                            <thead class="" style="">
                                <tr class="table-head"><td class="text-center">Customer Reference</td>
                                <td class="text-center">Bank Account Name</td>
                                <td class="text-center">Bank Account Number</td>
                               <td class="text-center">Amount</td>
                               <td class="text-center">Payment Initiation Date</td>
                               <td class="text-center">Payment Execution Date</td>
                               <td class="text-center">Payee Bank Account No</td>
                               <td class="text-center">Routing No</td>
                               <td class="text-center">Bank Name</td>
                               <td class="text-center">Email</td>
                               <td class="text-center">Reason</td>
                               <td class="text-center">Payee Account Type</td>
                               <td class="text-center">Payment Mode</td></tr>
                            </thead>
                            <tbody>
                                
                                <tr class="table-row hover-bg " v-for="ndetail in detail.data" :key="ndetail.customer_refference">
                                    <!--aboni 10-11-21-->
                                    <template v-for="(v,i,count) in ndetail">
                                        <td class="2" v-if="i != 'amount'">
                                            {{v}}
                                        </td>
                                        <td v-else class="2 text-right">
                                            <div v-if="v==0">
                                                --
                                            </div>
                                            <div v-else>
                                                {{formatMoney(v)}}
                                            </div>
                                        </td>
                                    </template>
                                    <!--aboni 10-11-21-->
                                </tr>
                            </tbody>
                            </table>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 text-center pr-0">
                    
                        <button v-if="$acl['pf/allloanapplications'] > 1" v-on:click="downloadBankFile()" class="btn btn-primary position-static">Download Bank File</button>
                    
                        <!-- Start: Rejwan: 24-08-2026 -->
                        <!-- <button v-if="$acl['pf/allloanapplications'] > 1" v-on:click="showUnApproveModal()" class="btn btn-primary position-static">Send File to Bank for Disbursement</button> -->
                        <button v-if="$acl['pf/allloanapplications'] > 1" v-on:click="showUnApproveModal()" class="btn btn-primary position-static">Disburse</button>
                        <!-- End: Rejwan: 24-08-2026 -->
                    
                    
                    </div>
                </div>
                <div v-else>
                    <div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                        No Advance found to generate Bank File.
                    </div>
                </div>
            </b-overlay>
        </b-modal> 
        <b-modal id="pass-modal" title="Are you sure to Send the Disbursement Instruction to the Bank?" hide-footer> Please enter your password to continue:
            <br />
            <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 
            <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="sendBankFile()">Send <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('pass-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
       
        

    </div>
</template>


<script>
    export default{
        mounted() {

        },
        props: ['pageurl','flg','is_trustee'],
        data(){            
            
            return {
                
                loans:[], 
                loan_id:'',
                employee_id:'',
                tx_popup_count:0,
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#009efb !important',
                my_installments:[],
                is_custom:'',
                is_status:'',    
                action_btn_text:'Download Schedule',         
                bank_names: [
                    { value: null, text: "--Select--" },
                ],  
                modal_title:'',
                count:'', 
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                default_tenure: [0,150,0],
                showoverlay_list : false,                          
                successmsg:'',
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                showoverlaymodal : false,
                show_loader:true,
                loan_entity_id:'',
                loan_update_status:'',
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Declined" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approved" },
                    { value: "3", text: "Pause/Stopped" },
                    { value: "4", text: "Returned" },
                ],
                 /**Child Component property data */
                is_action:1,
                checkbox:0, 
                list_key:0,
                loans:[],   
                default_column:['name','employee_code'],
                appended_column:[
                    { value: "company_loan_id", text: "Advance ID",type: "text"},
                    // { value: "loan_amount", text: "Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "loan_amount", text: "Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "effective_date_of_loan", text: "Application Date",type: "date"},
                    { value: "loan_status", text: "Status",type: "text"},
                ],
                primary_key:'id', 
                company_options:[],
                tmp_loans:[],
                approver_settings:[],
                /***Child Component property data */

                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',
                btn_name:'',
                loading:'',
                emp_id:'',
                emp_name:'',
                preview_list:[],
                show_bank_preview:false,
            }
        },
        methods:{
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  
            
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            showUnApproveModal: function(pageflg)
            {
                this.$bvModal.show('pass-modal'); 
                this.approvepass='';
            },
            previewBankFile: function()
            {
                if(!this.checkNet()) return false;
                
                let url = ''
               
                url = this.$api_url + '/pf/loan/disburse/preview-bank-file';
            
                let formData = new FormData();
            
                let currentObj = this;
                this.show_bank_preview = true;
                axios.post(url, formData).then(function (response) 
                {
                    
                    if(response.data.errors)
                    {
                        this.show_bank_preview = false;
                        this.preview_list = [];
                    } 
                    else
                    {
                        this.show_bank_preview = false;
                        this.preview_list = response.data;
                        console.log(this.preview_list);
                        this.modal_title = "Bank File Preview";
                        this.$bvModal.show('bv-modal-bank-file-preview');
                    }
   
                    
                }.bind(this))
                .catch(error => {
                    if(error.response){
                        
                        this.show_bank_preview = false;
                    }
                });
                return false;
            },
            downloadBankFile: function()
            {
                if(!this.checkNet()) return false;
            
                let url = ''
               
                url = this.$api_url + '/pf/loan/disburse/preview-bank-file';
                


                // if(this.column_selected.indexOf('name') === -1){
                //     this.column_selected.unshift('name');
                // }

                let formData = new FormData();
                formData.append('download', 1);   
                let currentObj = this;
                this.show_bank_preview = true;
                this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'show_bank_preview'
                ); 
                return false;
            },
            
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            sendBankFile: function()
            {
                if(!this.checkNet()) return false;
            
                if(this.approvepass == '') return false;

                this.loading='load';
                 
                let url = ''
               
                url = this.$api_url + '/pf/loan/disburse/send-bank-file';
                


                // if(this.column_selected.indexOf('name') === -1){
                //     this.column_selected.unshift('name');
                // }

                let formData = new FormData();
                let currentObj = this;
                this.show_bank_preview = true;
                formData.append('pass', this.approvepass);  
                axios.post(url, formData).then(function (response) 
                {
                    
                    if(response.data.errors)
                    {
                        currentObj.incorrectpass="Incorrect Password";
                        currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                    } 
                    else
                    {
                        currentObj.$bvToast.toast('File Sent !', {title: 'Success',variant: 'success',solid: true, toaster: "toaster: b-toaster-top-right"});
                        currentObj.$bvModal.hide('pass-modal');
                    }

                    currentObj.getLoanData();
                    currentObj.loading='';  
                    currentObj.show_bank_preview = false;
                    currentObj.$bvModal.hide('bv-modal-bank-file-preview');
                    
                    
                    
                }.bind(this))
                .catch(error => {
                    if(error.response){
                        currentObj.$bvToast.toast('Error Occued !', {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                        this.show_bank_preview = false;
                    }
                });
                return false;
            },
          
            
            
            listReturn:function(data)
            {



                if(data.action_id == 0)
                {
                    let currentObj = this;
                    
                    let formData = new FormData();
                    
                    formData.append('loan_id', data.id); 
                    formData.append('employee_id', data.employee_id);
                    formData.append('d_type', 'excel'); 
                    this.pfoverlay = true;
                    this.report_data = [];
                    this.installments = [];
                    this.transactions = [];
                    this.employee_info = [];
                    
                    this.downloadBlobResponse(
                        axios.post(this.$api_url + '/pf/report/schedule', formData, { responseType: 'blob' }),
                        'showoverlay_list' // your loader key in this component
                    );

                }
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.id > 0)
                    {
                        var item  = this.loans.find(item => item.id === data.id); 
                        
                        if(data.action_id == 0)
                        {
                            //this.showEmployeeDetails(data.id);
                        }
                        else if(data.action_id == 1)
                        {
                             this.editLoanInfo(data.id,item.employee_id,item.name,0,0);
                        }
                        else if(data.action_id == 2)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,1,0);
                        }
                        else if(data.action_id == 3)
                        {
                            this.showDeclineModal(data.id);
                        }
                        else if(data.action_id == 4)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,0,3);
                        }
                        else if(data.action_id == 5)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,0,2);
                        }
                        else if(data.action_id == 6)
                        {
                            this.showInstallment(data.id);
                        }
                        else if(data.action_id == 7)
                        {
                            this.editLoanInfo(data.id,item.employee_id,item.name,0,1);
                        }
                        else if(data.action_id == 8)
                        {
                            this.showLoanTransactions(data.id);
                        }
                        else if(data.action_id == 9)
                        {
                            this.showDeleteModal(data.id);
                        }
                    }

                }
            },
            getLoanData: function(response) // Rejwan: 09-03-2025
            {
                // Start: Rejwan: 09-03-2025
                if (response && response.success == false) {
                    console.log(response);
                    this.$bvToast.toast(response.message, {
                        title: `Error`,
                        variant: 'danger',
                        solid: true
                    });
                }
                // End: Rejwan: 09-03-2025
                
                this.loan_title = 'PF Application Lists';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                currentObj.show_loader = true;
                
                axios.get(this.$api_url+'/pf/loan/applications' , {
                    params: {
                        approve_list:1,
                    }
                }).then(function(response){
                    currentObj.tmp_loans = response.data.employee_data;
                     currentObj.company_options = response.data.options;
                    
                    if(currentObj.tmp_loans.length > 0 )
                    {
                        currentObj.tmp_loans.forEach(element => {
                                if(element.id > 0)
                                {
                                    let depth = parseInt(currentObj.approver_settings.depth);
                                    element.loan_amount = currentObj.formatMoney(element.loan_amount);
                                    let dop = []; 
                                    if(element.loan_status == "Approved")
                                    {
                                        dop = dop.concat([{ label: 'Disburse' , value: 5 }]);
                                    }
                                    element.actions = dop;
                                }
                            });
                        
                    }
                    console.log('currentObj.tmp_loans');
                    console.log(currentObj.tmp_loans);
                    currentObj.$bvModal.hide('bv-modal-loan-2');
                    if(this.is_trustee != null && this.is_trustee == 1)
                    {
                        this.is_action = 0;
                    }
                    currentObj.loans = currentObj.tmp_loans;
                    currentObj.list_key = currentObj.list_key + 1;
                    
                    currentObj.show_loader = false;
                }.bind(this)).catch(function (error){ 

                    currentObj.show_loader = false;
                    currentObj.serverError(error);
                    
                    });

            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan-2');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            editLoanInfo(loan_id,emp_id,emp_name,is_custom,is_status)
            {
                this.modal_title = "PF Advance Application";
                this.is_custom = is_custom;
                this.loan_id = loan_id; 
                this.is_status = is_status;
                this.count = this.count + 1;
                this.emp_id = emp_id;
                this.emp_name = emp_name;
                this.$bvModal.show('bv-modal-loan-2');
            }, 
            getApprovalSettings()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/approver/company-settings', {
                    params: {
                        module: 7
                    }
                }).then(function(response){
                    this.approver_settings = response.data;
                    this.getLoanData();
               
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            }
        },
        created: function(){
           
            this.getApprovalSettings();

            //this.updateTransactions();
        }
    }
</script>
